/** Date the release log was last edited, shown in the hero. */
export const CHANGELOG_UPDATED_AT = "2026-10-27";

/** Pixel size of every demo capture in `public/changelog`, used to reserve layout space. */
export const DEMO_MEDIA_WIDTH = 1600;
export const DEMO_MEDIA_HEIGHT = 1220;

/**
 * Band near the top of the viewport that decides the active month in the rail: a release is
 * active once its heading crosses 20% from the top and until it leaves the upper 30%.
 */
export const ACTIVE_RELEASE_ROOT_MARGIN = "-20% 0px -70% 0px";
